<script setup>
import { ref } from 'vue'
import { ChevronDown } from 'lucide-vue-next'

defineProps({
  items: { type: Array, required: true },
})

const open = ref(null)
const toggle = (id) => (open.value = open.value === id ? null : id)
</script>

<template>
  <ul class="divide-y divide-slate-100 overflow-hidden rounded-lg border border-slate-100">
    <li v-for="item in items" :key="item.id">
      <button
        type="button"
        class="flex w-full items-center gap-3 px-4 py-3.5 text-left transition-colors hover:bg-up-bg"
        :aria-expanded="open === item.id"
        @click="toggle(item.id)"
      >
        <span class="text-sm font-medium text-up-navy">{{ item.question }}</span>
        <ChevronDown
          class="ml-auto h-4 w-4 shrink-0 text-slate-400 transition-transform"
          :class="open === item.id && 'rotate-180'"
          aria-hidden="true"
        />
      </button>
      <p v-if="open === item.id" class="border-t border-slate-100 bg-up-bg px-4 py-3.5 text-sm leading-relaxed text-slate-600">
        {{ item.answer }}
      </p>
    </li>
  </ul>
</template>
